import React, { useEffect, useMemo, useState } from 'react';
import { useInView } from 'react-intersection-observer';

import { fullDataResponseApi } from '@/api/clients';
import AppLoader from '@/react_app/common/AppLoader';
export interface Response<T = unknown> {
	count: number;
	results: T[];
	next: string | null;
	previous: string | null;
}
const AppPagination = ({
	children,
	getData,
	setResults,
}: {
	children: React.ReactNode;
	getData: () => Promise<Response<unknown>>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setResults: React.Dispatch<React.SetStateAction<any[]>>;
}) => {
	const { ref, inView } = useInView({});
	const [latestResponse, setLatestResponse] = useState<Response | null>(null);
	const [showErrorMessage, setShowErrorMessage] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingPagination, setIsLoadingPagination] = useState(false);

	const hasMoreData = useMemo(() => !!latestResponse?.next, [latestResponse]);

	const fetchFirstPage = async () => {
		try {
			setIsLoading(true);
			const res = await getData();
			setLatestResponse(res);
			setResults((currentResults) => [...currentResults, ...res.results]);
		} catch {
			onError();
		} finally {
			setIsLoading(false);
		}
	};

	const onError = () => {
		setShowErrorMessage(true);
		setLatestResponse(null);
		console.log('showErrorMessage:', showErrorMessage);
		throw new Error('Error in fetching data');
	};

	const fetchNextPage = async () => {
		setIsLoadingPagination(true);
		try {
			// @ts-ignore
			const res: Response<unknown> = await fullDataResponseApi.get(latestResponse.next);
			setResults((currentResults) => [...currentResults, ...res.results]);
			setLatestResponse(res);
		} catch {
			onError();
		} finally {
			setIsLoadingPagination(false);
		}
	};

	useEffect(() => {
		fetchFirstPage();
	}, []);
	useEffect(() => {
		if (inView && hasMoreData && latestResponse?.next) {
			fetchNextPage();
		}
	}, [inView, hasMoreData, latestResponse]);

	return (
		<div>
			{isLoading ? (
				<div className="width-100 flex-centerize" ref={ref}>
					<AppLoader />
				</div>
			) : (
				children && <React.Fragment>{children}</React.Fragment>
			)}
			{hasMoreData && (
				<div className="width-100 flex-centerize mt-10" ref={ref}>
					{isLoadingPagination && <AppLoader />}
				</div>
			)}
		</div>
	);
};

export default AppPagination;
